// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3I7sS","empty":"ModalGraph_empty__312D0"};